import React, { useEffect, useState } from 'react'
import ssoHandler from '../ssoHandler';
import Loader from '../../components/Loader';
import { useAppServices } from '../../hook/services';
import env from '../../config/env';

const iframeStyles = {
    width: "100%",
    height: "100vh",
    border: "none",
};

const SSOIframe = () => {
    const { SSO, checkSSO } = ssoHandler();
    const [ssodata, setssodata] = useState({})
    const [loader, setloader] = useState(true)
    const [agency_loc, setagency_loc] = useState("")
    const AppService = useAppServices();
    const Agency_level = `${env.AGENCY_LEVEL}`;
    const Account_level = `${env.ACCOUNT_LEVEL}`;

    useEffect(() => {
        checkSSO();
    }, []);

    const getAgency = async (data) => {
        const { response } = await AppService.agency.get({
            query: `company_id=${data.companyId}`
        });
        if (response.data.location_id != undefined && response.data.location_id != "") {
            setagency_loc(response.data.location_id)
            setloader(false);
        } else {
            setagency_loc(response.data.ghl.location_id)
            setloader(false);
        }
    }
    const updateAgency = async (data) => {
        const payload = {
            company_id: data.companyId,
            planId: data.planId,
        }
        await AppService.agency.update_by_company_id({ payload });
    }
    const checkLocation = async (data) => {
        const payload = {
            locationId: data?.activeLocation,
            companyId: data?.companyId,
            userId: data?.userId,
            planId: data?.planId,
        }

        const { response } = await AppService.webhook.check_location({ payload });

        if (response.success) {
            setloader(false);
        }
    }

    useEffect(() => {
        if (SSO != '' && SSO != undefined) {
            var data = JSON.parse(SSO)
            if (data?.planId) {
                updateAgency(data)
            }
            setssodata(data)
            if (data.activeLocation) {
                checkLocation(data)
                setagency_loc(data.activeLocation);
            } else {
                getAgency(data)
            }
        }
    }, [SSO]);

    const encryptedData = btoa(`${ssodata?.email}:${ssodata?.activeLocation}`)
    return (
        <div>
            {
                loader ?
                    <Loader />
                    :
                    <>
                        {ssodata?.activeLocation ?
                            <iframe style={iframeStyles} src={`${Account_level}/${btoa(`${ssodata?.email}:${ssodata?.activeLocation}`)}/app/chatapp`}></iframe>
                            :
                            <iframe style={iframeStyles} src={`https://product1.trustbrand.ai/${btoa(`${ssodata?.email}:${agency_loc}`)}/iframe`}></iframe>
                        }
                    </>
            }
        </div>
    )
}

export default SSOIframe
